let fetch = null

export const use = function (instance) {
  fetch = instance
}

export const useFetch = function (...args) {
  return fetch.call(null, ...args)
}

export default {
  use,
  useFetch,
}
